import { PALETTES, type Palette } from "./palettes.ts";

/** Запись покедекса палитр: номер, цвета и эксклюзив ли она (такие надеваются NFC-меткой на открытке). */
export type DexEntry = Palette & { number: number; exclusive: boolean };

// Эксклюзивы живут только в прошивке, в palettes.ts их нет.
const EXCLUSIVES: Palette[] = [
  { id: "retro_tv", name: "Retro-TV", bg: "#dde9ea", text: "#48655e", dim: "#799088", accent: "#8db9dc", accent2: "#bcd4e9" },
];

export const DEX: readonly DexEntry[] = [
  ...PALETTES.map(palette => ({ ...palette, exclusive: false })),
  ...EXCLUSIVES.map(palette => ({ ...palette, exclusive: true })),
].map((entry, index) => ({ ...entry, number: index + 1 }));

export function dexNumber(entry: DexEntry) {
  return `#${String(entry.number).padStart(3, "0")}`;
}
